import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const Billable = () => {
    const config: MasterConfigs = {
        modalTitle: () => 'Billable',
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                width: '20%',
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                sorter: true,
                width: '20%',
            },
            {
                title: 'Role',
                dataIndex: 'role',
                key: 'role',
                sorter: true,
                width: '20%',
            },
            {
                title: 'Salary',
                dataIndex: 'salary',
                key: 'salary',
                sorter: true,
            },
            {
                title: 'Total Billing',
                dataIndex: 'totalBilling',
                key: 'totalBilling',
                sorter: true,
            },
            {
                title: 'Total Billing',
                dataIndex: 'totalBilling',
                key: 'totalBilling',
                sorter: true,
            },
        ],
        getFormColumns: () => [],
    }
    return (
        <MasterComponent config={config} />
    );
}

export default Billable;